import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/lib/auth-store';

/**
 * Lindungi route yang butuh login. Kalau belum auth → redirect ke /app/login.
 * Saat `booting` (baru load, belum fetch /me), render null supaya tidak flicker.
 */
export function ProtectedRoute({ children }: { children: ReactNode }) {
    const booting = useAuthStore((s) => s.booting);
    const isAuth = useAuthStore((s) => s.isAuthenticated);

    if (booting) return null;
    if (!isAuth) return <Navigate to="/app/login" replace />;
    return <>{children}</>;
}

/**
 * Untuk halaman public-only (e.g. LoginScreen). Kalau sudah auth → ke dashboard.
 */
export function PublicOnlyRoute({ children }: { children: ReactNode }) {
    const booting = useAuthStore((s) => s.booting);
    const isAuth = useAuthStore((s) => s.isAuthenticated);

    if (booting) return null;
    if (isAuth) return <Navigate to="/app/dashboard" replace />;
    return <>{children}</>;
}
